export function asDictionary (attributes, keyKey, valueKey) {
  const dictionary = {};

  attributes.forEach((attribute) => {
    dictionary[attribute[keyKey]] = attribute[valueKey];
  });

  return dictionary;
}
